document.addEventListener('DOMContentLoaded', function () {
  let currentSlide = 0; // Huidige afbeelding
  const slides = [
    {
      image: "https://cdn.shopify.com/s/files/1/0891/4390/2550/files/C48647F2-9FF5-48FB-9E2E-E83433B95BB5.png?v=1737213546", 
      heading: "Zoomly Pro MAX", 
      description: "Erleben Sie die schärfsten Projektionen und ein echtes Kinoerlebnis bei Ihnen zu Hause.", 
      buttonText: "Entdecken Sie den Pro Max",
      buttonLink: "/collections/projectors"
    },
    {
      image: "https://cdn.shopify.com/s/files/1/0891/4390/2550/files/4EF5934A-B35B-44C9-81B7-CC89A30531AE.png?v=1737219196", 
      heading: "Zoomly Digitale Bilderrahmen", 
      description: "Bringen Sie Ihre schönsten Erinnerungen mit den stilvollen und vielseitigen digitalen Bilderrahmen von Zoomly zum Leben.",
      buttonText: "Entdecken Sie die Bilderrahmen",
      buttonLink: "/collections/photo-frames"
    }
  ];

  const announcementBar = document.getElementById('announcement-bar');
  const progressBar = document.querySelector('.progress-bar .progress');
  const slideImage = document.querySelector('.slide-image');
  const slideHeading = document.querySelector('.text-container h2');
  const slideDescription = document.querySelector('.text-container p');
  const button = document.querySelector('.banner-button');
  
  const slideInterval = 6000; // 6 seconden

  // Functie om de slide te wijzigen
  function changeSlide() {
    // Update de tekst en afbeelding
    const slide = slides[currentSlide];
    slideImage.src = slide.image;
    slideHeading.textContent = slide.heading;
    slideDescription.textContent = slide.description;
    button.textContent = slide.buttonText;
    button.href = slide.buttonLink;

    // Verander de announcement bar voor elke slide
    if (currentSlide === 1) {
      announcementBar.innerHTML = "<span>30 Tage Rückgaberecht ohne Probleme!</span>";
    } else {
      announcementBar.innerHTML = "<span>Kostenloser Versand bei allen Bestellungen!</span>";
    }

    // Update de voortgangsbalk
    updateProgressBar();

    // Zet de volgende slide in de wacht
    currentSlide = (currentSlide + 1) % slides.length;
  }

  // Functie om de voortgangsbalk bij te werken
  function updateProgressBar() {
    let progressWidth = (currentSlide + 1) / slides.length * 100;
    progressBar.style.width = `${progressWidth}%`;
  }

  // Start de eerste wijziging van de slide
  changeSlide();

  // Start het interval voor de slides
  setInterval(changeSlide, slideInterval);
});


